/**
 * Checks if an image URL is valid and accessible by making a HTTP request.
 * Uses the 'HEAD' method to request only the headers of the image,
 * which is more efficient than downloading the entire image content.
 */

export function canGetImage(url: string) {
  if (url?.startsWith('data:image')) {
    return Promise.resolve(true);
  } else {
    return fetch(url, {method: 'HEAD'})
      .then(response => {
        return response.ok;
      })
      .catch(error => {
        return false;
      });
  }
}
